import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import Select from 'react-select';

const ModelEdit = ({ match }) => {
    const { id } = useParams();
    const recordId = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        fetchBrandTypes();
    }, [isAuthenticated, companyId, token, logout]);

    const [formData, setFormData] = useState({
        name: '',
        brandId:'',
        isSubmit: false
    });

    useEffect(() => {
        fetchData('ProductModalApi', `/PmodelData/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Category Details:', error);
            });
    }, [id]);


    const [requestTypeOptions, setRequestTypeOptions] = useState([]);
    const [selectedRequestType, setSelectedRequestType] = useState(null);

    const fetchBrandTypes = async () => {
        try {
            const response = await fetchData('BrandApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(product => ({
                    value: product.id,
                    label: product.name
                }));
                setRequestTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Brand Types:', error);
        }
    };

    const handleBrandChange = async (selectedOption) => {
        setSelectedRequestType(selectedOption);
    };


    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);
    
        // Ensure that required fields are provided
        if (!formData.model) {
            alert("Model is required");
            setIsLoading(false);
            return;
        }
    
        const updatedFormData = {
            BrandId: selectedRequestType?.value || formData.brandId || '',  // Ensure BrandId is a valid value
            Model: formData.model,
            Id: id,
            ModifiedBy: userId,
            CompanyId : companyId,
            CreatedBy: formData.createdBy,
            CreatedDate : formData.createdDate,
            IsActive : formData.isActive
        };
    
        // Update data using API
        updateData('ProductModalApi', `${id}`, updatedFormData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/ModelIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error.response.data);
                // Handle error and display the error message if needed
                if (error.response && error.response.data) {
                    console.error('Validation errors:', error.response.data.errors);
                }
                setIsLoading(false);
            });
    };
    

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <form onSubmit={handleSubmit}>
                <div className='w-full mb-2 flex items-center'>
                    <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>PRODUCT MODEL EDIT</h6>

                    <Tooltip title="Exit">
                        <Link to="/ModelIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                            <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                Exit <ExitToAppIcon />
                            </Button>
                        </Link>
                    </Tooltip>


                    <Tooltip title="Update">

                        <Button onClick={handleSubmit} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
                        </Button>

                    </Tooltip>

                </div>
                {/* Display success and error messages if needed */}
                {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                {successMessage && <p className="text-green-500">{successMessage}</p>}


                <div className="w-full mb-4 flex">
                    <div className="w-1/4 mr-2">
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="name">
                            Brand
                        </label>
                        <Select
                            //value={selectedRequestType}
                            value={selectedRequestType || (formData.brand ? { value: formData.brandId, label: formData.brand } : '')}
                            onChange={handleBrandChange}
                            options={requestTypeOptions}
                            placeholder="Select Brand"
                            isSearchable
                        />
                    </div>
                    <div className="w-1/2 mr-2">
                        <label className="block tracking-wide text-black text-base font-bold mb-2" htmlFor="Name">
                            Product Model
                        </label>
                        <input
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            name="model"
                            value={formData.model}
                            onChange={handleChange}
                            type="text"
                            placeholder="Enter Product Model"
                        />
                    </div>

                </div>
            </form>
        </div>
    );
};

export default ModelEdit;
